export default __webpack_public_path__ + "static/media/non-certificate.06fa0911.svg";